import React from "react";
import { Car, Truck, Bike, Package, BatteryWarning, Wrench } from "lucide-react";
import { WHATSAPP_URL } from "../lib/business";

const SERVICES = [
  {
    icon: Car,
    title: "Guincho para Veículos Leves",
    desc: "Remoção rápida e segura de carros nacionais e importados. Seja para panes mecânicas, elétrica, colisões e quebras em qualquer ponto da cidade ou rodovia.",
    keywords: "guincho em Araçoiaba da Serra",
  },
  {
    icon: Truck,
    title: "Guincho para Camionetes",
    desc: "Equipamento reforçado para utilitários, pickups e veículos maiores. Capacidade para transportar Hilux, S10, Ranger e similares.",
    keywords: "reboque de camionetes Sorocaba",
  },
  {
    icon: Bike,
    title: "Guincho para Motos",
    desc: "Transporte especializado para motos de todas as cilindradas, sem risco de avarias. Calços e cintas adequadas para motos esportivas e custom.",
    keywords: "guincho para motos Araçoiaba da Serra",
  },
  {
    icon: Package,
    title: "Transporte de Materiais",
    desc: "Levamos máquinas pequenas, peças, cargas, materiais de construção e equipamentos diversos com total segurança.",
    keywords: "transporte de carga região",
  },
  {
    icon: BatteryWarning,
    title: "Socorro Emergencial",
    desc: "Pane Mecânica, Pane Elétrica, Colisões e qualquer imprevisto. Chegamos rápido para resolver o seu problema.",
    keywords: "auto socorro Araçoiaba da Serra",
  },
  {
    icon: Wrench,
    title: "Remoção para Oficina",
    desc: "Se o reparo for necessário, levamos direto para nosso centro automotivo, economizando seu tempo e dinheiro. Levando até nosso centro automotivo você tem desconto no guincho e orçamento gratuito para o reparo do seu veículo!",
    keywords: "remoção de veículos Sorocaba",
  },
];

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="bg-[#0A0A0A] py-16 md:py-24 relative">
      <div className="absolute top-0 left-0 right-0 h-[4px] stripes opacity-80" aria-hidden />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-[#E50914] px-3 py-1 mb-4">
            <span className="font-anton text-sm uppercase tracking-widest text-white">Nossos Serviços</span>
          </div>
          <h2 className="font-anton text-4xl md:text-6xl uppercase text-white leading-none mb-4">
            Solução Completa para
            <br />
            <span className="text-[#E50914]">Qualquer Emergência</span>
          </h2>
          <p className="font-work text-lg text-zinc-300 max-w-2xl mx-auto">
            Do guincho leve ao transporte de materiais, estamos preparados para todo tipo de situação em Araçoiaba da Serra, Sorocaba, São Paulo e toda região.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="group relative bg-[#171717] border-2 border-zinc-800 hover:border-[#E50914] p-6 md:p-8 transition-all hover-lift"
            >
              <div className="absolute top-0 right-0 bg-[#E50914] text-white font-anton text-xs uppercase tracking-widest px-3 py-1">
                0{i + 1}
              </div>
              <div className="w-14 h-14 bg-[#E50914]/10 group-hover:bg-[#E50914] flex items-center justify-center mb-5 transition-colors">
                <s.icon className="w-8 h-8 text-[#E50914] group-hover:text-white transition-colors" strokeWidth={2} />
              </div>
              <h3 className="font-anton text-2xl md:text-3xl text-white uppercase leading-tight mb-3">
                {s.title}
              </h3>
              <p className="font-work text-zinc-300 text-sm md:text-base leading-relaxed">{s.desc}</p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center gap-2 font-anton text-sm uppercase tracking-widest text-[#E50914] hover:text-white transition-colors"
              >
                Solicitar →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
